/** Public landing screenshots (PNG exports from the product UI). */
export const LANDING_SCREEN = {
  clientHome: "/landing/screen-client-home.png",
  clientSchedule: "/landing/screen-client-schedule.svg",
  trainerJournal: "/landing/screen-manage-journal.png",
  adminClients: "/landing/screen-manage-clients.png",
  staffOverview: "/landing/screen-staff-overview.png",
  manageCalendar: "/landing/screen-manage-calendar.png",
  manageJournal: "/landing/screen-manage-journal.png",
  manageOverview: "/landing/screen-manage-dashboard.png",
  manageFinance: "/landing/screen-manage-finance.png",
};
